import './ClientInstance.css';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ClientInstanceService from '../Services/InstanceService';
import ClientDisplayWindow from './ClientDisplayWindow';
import EnterInstanceName from './Components/EnterInstanceName';
import LoadingInstanceData from './Components/LoadingInstanceData';
import {SERVER_URL} from '../Constants';

// - - - - - - - - - - - API INTERACTIONS - - - - - - - - - - - - 

const fetchClientInstanceData = async (clientInstance, setSuccess, setFailure) => {
    try{
        const response = await ClientInstanceService.checkValidInstance(clientInstance);
        if(response.status >= 200 && response.status < 300) {
            setFailure(null);
            setSuccess(response.data);
        } else {
            setSuccess(null);
            setFailure(`Instance "${clientInstance}" not found.`);
        };
    } catch(error) {
        setSuccess(null);
        setFailure(`Instance "${clientInstance}" not found.`);
    };
};

// - - - - - - - - - - - COMPONENTS - - - - - - - - - - - - 

const ClientInstance = () => {
    const { clientInstance } = useParams();
    const [ instanceName, setInstanceName ] = useState('');
    const [ clientInstanceData, setClientInstanceData ] = useState(null);
    const [ clientInstanceError, setClientInstanceError ] = useState(null);

    useEffect(() => {  
        if(clientInstance) setInstanceName(clientInstance);
    }, [clientInstance]);

    useEffect(() => {
        if(instanceName) fetchClientInstanceData(instanceName, setClientInstanceData, setClientInstanceError);
    }, [instanceName]);

    const clientDisplayWindowProps = {
        clientInstanceData,
    };

    const enterInstanceNameProps = {
        clientInstanceError,
        redirectRoute: SERVER_URL,
    };

    return (
        <div className="client-instance">
            {   clientInstance ?
                <>
                {   clientInstanceError ?
                    <EnterInstanceName {...enterInstanceNameProps}/>
                :
                    <>
                    {   clientInstanceData ?
                        <ClientDisplayWindow {...clientDisplayWindowProps} />
                    : 
                        <LoadingInstanceData clientInstance={clientInstance}/>
                    }
                    </>
                }
                </>
            :
                <EnterInstanceName {...enterInstanceNameProps}/>
            }
        </div>
    );
};

export default ClientInstance;